module.exports = __webpack_public_path__ + "static/media/34DSS8.f0e610be.jpg";